import { INBOUND_TICKET_FIELD_MAP } from 'utils/constants'

// TODO: create a general type for contact
type Contact = {
  firstName: string
  lastName: string
}

export const translateFieldValue = (id: string, value: unknown) => {
  if (id === INBOUND_TICKET_FIELD_MAP.NOTES.id) {
    return value?.[0]?.name || 'None'
  }
  if (id === INBOUND_TICKET_FIELD_MAP.CONTACT.id) {
    return value ? `${(value as Contact).firstName ?? ''} ${(value as Contact).lastName ?? ''}`.trim() : 'None'
  }
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No'
  }
  return value || 'None'
}
